import {string} from 'io-ts';

export const NonEmptyString = string;
export type NonEmptyString = string;
